import React from 'react';
import { Table } from 'semantic-ui-react';

import { LinkAlumno } from 'src/componentes';
import { OtrosTelefonos } from './OtrosTelefonos';
import { DatosDeContactoDeAlumno } from './tipos';

export const Tabla = (props: { matriculas: ReadonlyArray<DatosDeContactoDeAlumno> }) => {
    const { matriculas } = props;

    return (
        <Table attached='bottom'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Alumno</Table.HeaderCell>
                    <Table.HeaderCell>RUT/Pasaporte</Table.HeaderCell>
                    <Table.HeaderCell>N° matrícula</Table.HeaderCell>
                    <Table.HeaderCell>Correo</Table.HeaderCell>
                    <Table.HeaderCell>Móvil</Table.HeaderCell>
                    <Table.HeaderCell>Área</Table.HeaderCell>
                    <Table.HeaderCell>Plan</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {matriculas.map((matricula, indice) => {
                    return (
                        <Table.Row key={indice}>
                            <LinkAlumno
                                numeroDeContrato={matricula.numeroDeContrato}
                                nombre={matricula.nombreAlumno}
                                paraTabla
                            />

                            <Table.Cell>{matricula.rutPasaporteAlumno}</Table.Cell>

                            <Table.Cell textAlign='right'>{matricula.numeroDeContrato}</Table.Cell>

                            <Table.Cell>
                                {matricula.correosAlumno.map((correo, index) => {
                                    if (index !== 0) {
                                        return (
                                            <a href={'mailto:' + correo} key={index}>
                                                {', ' + correo}
                                            </a>
                                        );
                                    }
                                    return (
                                        <a href={'mailto:' + correo} key={index}>
                                            {correo}
                                        </a>
                                    );
                                })}
                            </Table.Cell>

                            <Table.Cell>
                                {`9 ${matricula.telefonosAlumno.movil.numero}`}
                                <OtrosTelefonos telefonos={matricula.telefonosAlumno} />
                            </Table.Cell>

                            <Table.Cell>{matricula.area === 'preu' ? 'Preu' : 'Inglés'}</Table.Cell>

                            <Table.Cell>
                                {matricula.plan === 'anual'
                                    ? 'Anual'
                                    : matricula.plan === 'intensivo'
                                    ? 'Intensivo'
                                    : 'Intensivo vesp.'}
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
            </Table.Body>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/ListaGeneral/Tabla.tsx